import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import personAddOutline from '@iconify/icons-eva/person-add-outline';
import fileFill from '@iconify/icons-eva/file-text-outline';
import autoSchedule from '@iconify/icons-material-symbols/auto-schedule';
import checkbookRounded from '@iconify/icons-material-symbols/checkbook-rounded';
// Add other icon imports...

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const getNavConfig = (account, hasCompany, hasDocuments, hasTraining) => {
  const {
    role
  } = account || {};

  const baseItems = [
    {
      title: 'dashboard',
      path: '/stores/app',
      icon: getIcon(pieChart2Fill),
    },
    {
      title: 'QR code',
      path: '/stores/qr',
      icon: getIcon('mdi:qrcode'),
    },
    {
      title: 'Biometrics',
      path: '/stores/biometric',
      icon: getIcon('mage:scan'),
    },
    {
      title: 'user',
      path: '/stores/user',
      icon: getIcon(personAddOutline),
    },
    {
      title: 'archived user',
      path: '/stores/archive',
      icon: getIcon('mdi:user-off-outline'),
    },
    {
      title: 'time adjustment',
      path: '/stores/adjustment',
      icon: getIcon('mdi:timer-edit-outline'),
    },
    {
      title: 'schedules',
      path: '/stores/schedule',
      icon: getIcon(autoSchedule),
    },
    {
      title: 'reports',
      path: '/stores/reports',
      icon: getIcon(fileFill),
    },
    {
      title: 'time records',
      path: '/stores/admin',
      icon: getIcon('clarity:administrator-line'),
    },
    {
      title: 'breaklist summary',
      path: '/stores/breaklist-info',
      icon: getIcon('clarity:administrator-line'),
    },
    {
      title: 'edit breaklist',
      path: '/stores/manage-breaklist',
      icon: getIcon(checkbookRounded),
    },
    {
      title: 'generated breaklist',
      path: '/stores/breaklist',
      icon: getIcon('icon-park-outline:view-grid-list'),
    },
    {
      title: 'announcements',
      path: '/stores/announcements',
      icon: getIcon('mingcute:announcement-line'),
    },
    {
      title: 'Activity Logs',
      path: '/stores/admin-activity-logs',
      icon: getIcon('icon-park-outline:log')
    },
  ];

  if (hasCompany && role === 1 || role === 3) {
    baseItems.push({
      title: 'my company',
      path: '/stores/admin-company',
      icon: getIcon('mdi:company'),
    });
  }

  if (hasDocuments && role === 1 || role === 3) {
    baseItems.push({
      title: 'Required Documents',
      path: '/stores/required-documents',
      icon: getIcon('icon-park-outline:view-grid-list'),
    });
  }

  if (hasTraining && role === 1 || role === 3) {
    baseItems.push({
      title: 'training and development',
      path: '/stores/training-development',
      icon: getIcon('icon-park-outline:view-grid-list'),
    });
  }


  if (role >= 3) {
    baseItems.push({
      title: 'dice game',
      path: '/stores/dice-game',
      icon: getIcon('icon-park-outline:view-grid-list'),
    });
  }
  
  if (role >= 3) {
    baseItems.push({
      title: 'holidays',
      path: '/stores/holidays',
      icon: getIcon('mdi:calendar-star')
    });
  }

  if (role === 4) {
    baseItems.push(
      {
        title: 'features',
        path: '/stores/features',
        icon: getIcon('eos-icons:activate-subscriptions-outlined'),
      },
      {
        title: 'store approval',
        path: '/stores/approval',
        icon: getIcon('flowbite:store-outline'),
      },
      {
        title: 'feedbacks',
        path: '/stores/feedbacks',
        icon: getIcon('icon-park-outline:view-grid-list'),
      },
      {
        title: 'my company',
        path: '/stores/admin-company',
        icon: getIcon('mdi:company'),
      },
      {
        title: 'Required Documents',
        path: '/stores/required-documents',
        icon: getIcon('icon-park-outline:view-grid-list'),
      }
    );
  }

  return baseItems;
};

export default getNavConfig;
